export default {"src":"/_next/static/media/liberty.cfc4cbd4.svg","height":283,"width":288};